/* esm.sh - esbuild bundle(micromark@3.1.0/lib/postprocess) deno production */
import{subtokenize as r}from"/v108/micromark-util-subtokenize@1.0.2/deno/micromark-util-subtokenize.js";function e(o){for(;!r(o););return o}export{e as postprocess};
//# sourceMappingURL=postprocess.js.map